<template>
  <div class="c-table" ref="recordtable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table
      class="common-el-table-styles summary-el-table-styles"
      ref="table"
      v-loading="loading"
      :data="data"
      :height="height"
      border
      stripe
      show-summary
      :summary-method="getSummaries"
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'state'"></div>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="showClick(scope.row)">查看明细</el-button>
          </div>
          <span v-else-if="col.key === 'amount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeDeviceMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeCreateRoleMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'roleBonus'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'activeBonus'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'createRoleBonus'">{{ scope.row[col.key] | toThousands }}</span>
          <!-- <span v-else-if="col.key === 'thirtyDayKpi'">{{scope.row[col.key] | toPercent}}</span> -->
          <span v-else-if="col.key === 'thirtySynthesizeRetain'">{{ scope.row[col.key] | toPercent }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeDeviceRetain'">{{ scope.row[col.key] | toPercent }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeCreateRoleRetain'">{{ scope.row[col.key] | toPercent }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { toPercentFixed, toThousands } from '@/common/js/filters'
export default {
  name: 'recordTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Object
    },
    type: {
      type: String
    },
    height: {
      type: Number
    }
  },
  methods: {
    showClick(row) {
      const { gameId, gameName, opId, name, mediaId, mediaName, reportTime } = row
      // 写入面包屑
      this.$store.commit('setIndexRoute', 'listrecord') // 返回的路由名称
      this.$store.commit('setBreadcrumb', [
        {
          title: '投放绩效考核列表',
          href: {
            to: 'record',
            query: {}
          }
        },
        {
          title: '明细'
        }
      ])
      this.$router.push({
        name: 'detailrecord',
        query: {
          opId,
          name: encodeURI(name),
          gameId,
          game: encodeURI(gameName),
          mediaId,
          media: encodeURI(mediaName),
          month: encodeURI(reportTime),
          type: this.type
        }
      })
    },
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const sumColumn = [
        'amount',
        'thirtySynthesizeMoney',
        'thirtySynthesizeDeviceMoney',
        'thirtySynthesizeCreateRoleMoney',
        'thirtySynthesizeDeviceRetain',
        'thirtySynthesizeRetain',
        'thirtySynthesizeCreateRoleRetain',
        'roleBonus',
        'activeBonus',
        'createRoleBonus'
      ]
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (sumColumn.includes(prop)) {
          let summaryVal = this.summary[prop] || 0
          if (prop === 'thirtySynthesizeRetain' || prop === 'thirtySynthesizeDeviceRetain' || prop === 'thirtySynthesizeCreateRoleRetain') {
            summaryVal = toPercentFixed(summaryVal)
          } else summaryVal = toThousands(summaryVal)
          sums[index] = summaryVal
        }
      })
      return sums
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    }
  }
}
</script>
